// extracted by mini-css-extract-plugin
module.exports = {"section9":"_____9_Desktop3_section9__xf0Rb"};